import React from "react";
import "./DateFormField.css";

const DateFormField = ({
  type = "date",
  label,
  value,
  appendIcon,
  containerClassName,
  ...props
}) => {
  return (
    <div className={`relative  ${containerClassName}`}>
      {label && (
        <label
          htmlFor="name"
          className="text-sm mb-1 block font-bold text-red-500"
        >
          {label}
        </label>
      )}
      <div className="relative bg-[#F8F8F8] rounded-[10px] flex items-center">
        <input type={type} className="myInput" {...props} />
        {appendIcon}
      </div>
    </div>
  );
};

export default DateFormField;
